/**
 * Strips markdown and planning metadata from UGC scripts so TTS / avatar reads
 * plain spoken lines instead of headings, **Length:** labels, etc.
 */
export function cleanVoiceoverScript(raw: string): string {
  if (!raw?.trim()) return raw?.trim() ?? '';

  let text = raw.replace(/\r\n/g, '\n').trim();

  // Drop everything before the main "Script" / voiceover block when clearly marked
  const scriptBlock = /^#{1,6}\s*Script\b[^\n]*/im.exec(text);
  if (scriptBlock?.index !== undefined) {
    const afterHeader = text.slice(scriptBlock.index + scriptBlock[0].length);
    text = afterHeader.replace(/^\s*\n+/, '');
  }

  const lines = text.split('\n');
  const cleaned: string[] = [];

  for (let line of lines) {
    const trimmed = line.trim();
    if (!trimmed) {
      cleaned.push('');
      continue;
    }

    if (/^[-*_]{3,}$/.test(trimmed)) continue;

    if (/^#{1,6}\s+/.test(trimmed)) continue;

    if (/^\*\*(?:Length|Style|Duration|Format|Audience|Tone|Hook|CTA|Call\s*to\s*action|Title|Platform|Aspect)\*\*:/i.test(trimmed)) {
      continue;
    }
    if (/^(?:Length|Style|Duration|Format|Audience|Tone)\s*:/i.test(trimmed)) continue;

    line = line.replace(/^\s*>\s?/, '');
    line = line.replace(/^\s*[-*+]\s+(?=\S)/, '');
    line = line.replace(/^\s*\d+\.\s+(?=\S)/, '');

    line = line.replace(/\*\*([^*]+)\*\*/g, '$1');
    line = line.replace(/\*([^*]+)\*/g, '$1');
    line = line.replace(/__([^_]+)__/g, '$1');
    line = line.replace(/_([^_\n]+)_/g, '$1');
    line = line.replace(/`([^`]+)`/g, '$1');
    line = line.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');

    cleaned.push(line.trimEnd());
  }

  return cleaned
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
